import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { Theme, css, styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const OuterFilterBox = styled(Box)`
  border: 1px solid
    ${({ $active, theme }: { $active: boolean; theme: Theme }) => ($active ? theme.palette.primary.main : colors.lightGrey)};
  border-radius: 4px;
  padding: 20px;
  background-color: ${colors.white};
  flex-grow: 0;
  ${({ $active }: { $active?: boolean }) =>
    $active
      ? css`
          box-shadow: 0px 0px 12px 2px #a5bcc433;
        `
      : ''}
  & + & {
    margin-top: 16px;
  }
`
export const FilterTitleBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const FilterAccordionTitle = styled(Typography)`
  display: flex;
  align-items: center;
`

export const FilterSkeletonBox = styled(Box)`
  min-height: 120px;
  padding: 20px;
  border: 1px solid ${colors.lightGrey};
  border-radius: 4px;

  & + & {
    margin-top: 20px;
  }
`

export const FilterSkeleton = styled(Skeleton)`
  width: 100%;
  height: 20px;
`

export const FilterSearchInput = styled(TextField)`
  margin-bottom: 16px;
  width: calc(100% + 5px);
  margin-left: -5px;

  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline,
  & .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${colors.primaryDark};
  }

  & .MuiOutlinedInput-root {
    height: 27px;
    border-radius: 0;
  }
` as typeof TextField

export const ShowMoreWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 12px;
  gap: 10px;
  cursor: pointer;
`
